<template>
  <Modal v-model="model" :title="title" sticky reset-drag-position @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="message_template_pop" width="800">
    <div class="input_single">
      <div class="font_style_set"><span style="color: #ed4014">*</span>模板标题:</div>
      <Input v-model="tittle" class="input_content"  placeholder="请输入模板标题"/>
    </div>
    <div class="input_single">
      <div class="font_style_set"><span style="color: #ed4014">*</span>模板内容:</div>
      <Input v-model="content" class="input_content" type="textarea"  placeholder="请输入模板内容"/>
    </div>
    <div class="input_single">
      <div class="font_style_set">模板描述:</div>
      <Input v-model="desc" class="input_content" type="textarea"   placeholder="请输入模板描述"/>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
      name: "MessageTemplateEditPop",
      props:{
        showNoteEdit:Boolean,
        noteContent:Array
      },
      data(){
        return{
          model:false,
          title:"添加短信模板",
          tittle:'',
          content:'',
          desc:'',
          id:'',
          menuId:'5_3-1'
        }
      },
      methods:{
        cancel:function () {
          this.$emit("closeNoteEdit",false);
        },
        save:function () {
          let that=this;
          if (!this.tittle){
            this.$Message.info("模板标题不能为空");
            return false;
          }
          if (!this.content){
            this.$Message.info("模板内容不能为空");
            return false;
          }
          let param={
            content:this.content,
            tittle:this.tittle,
            description:this.desc,
            id:this.id,
            journalType:"短信管理=>短信模板=>"+this.title,
            menuId:this.menuId
          };
          this.$http.post("message/doSave.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("操作成功");
            that.$emit("closeNoteEdit",true);
          })
        }
      },
      watch:{
        showNoteEdit:function () {
          this.model=this.showNoteEdit;
          this.menuId='5_3-1';
          if(this.noteContent.length>0){
            this.title="编辑短信模板";
            this.menuId='5_3-2';
          }
          this.id='';
          if(this.showNoteEdit){
            if(this.noteContent.length>0){
              this.tittle=this.noteContent[0].tittle;
              this.content=this.noteContent[0].content;
              this.desc=this.noteContent[0].description;
              this.id=this.noteContent[0].id;
              return;
            }
            this.tittle='';
            this.content='';
            this.desc='';
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MessageManage/MessageTemplateEditPop.vue